var BeoTextAreaCss = function (props) {
    if (!props.className) {
        props.className = "p-inputtextarea-sm w-full";
    }
};
export default BeoTextAreaCss;
